// extracted by mini-css-extract-plugin
export default {"mCard":"EB-z","image":"FB-z","imageNoBackground":"GB-z","imageHasCategory":"HB-z","fullWidth":"IB-z"};